import { combineReducers } from "redux";

import actions from "../actions";

const defaultState = {
  loading: true,
  result: null,
  result2: null,
  last_call: null,
  error: null
};


const userAlerts = (state = defaultState, action) => {
  switch (action.type) {
    case actions.SET_USER_ALERTS:
    //  console.log(action.payload);
      return Object.assign({}, state, {
        loading: false,
        result: action.payload,
        error: null
      });

      case actions.SET_USER_ALERTS_BY_REG:
      //  console.log(action.payload);
        return Object.assign({}, state, {
          loading: false,
          result2: action.payload,
          error: null
        });

        case actions.SET_USER_ALERTS_LAST_SEARCH:
        //  console.log(action.payload);
          return Object.assign({}, state, {
           last_call: action.payload
          });


    default:
      return state;
  }
};


export default userAlerts;
